// import React from "react";
// import Autocomplete from "@mui/material/Autocomplete";
// import TextField from "@mui/material/TextField";
// import { FormControl, FormHelperText, InputLabel, styled } from "@mui/material";

// const CustomAutocomplete = styled(Autocomplete)(({ theme }) => ({
//   marginTop: 24,
//   "& .MuiOutlinedInput-root": {
//     padding: "11px 12px",
//     backgroundColor: "#FFF",
//     "&.Mui-focused": {
//       boxShadow: "none",
//       "& .MuiOutlinedInput-notchedOutline": {
//         border: "1px solid #E8E8E8 !important",
//       },
//     },
//     "&:hover": {
//       border: "none !important",
//       "& .MuiOutlinedInput-notchedOutline": {
//         border: "1px solid #E8E8E8 !important",
//       },
//     },
//     "& .MuiAutocomplete-input": {
//       position: "relative",
//       backgroundColor: "#FFF",
//       fontSize: 14,
//       fontFamily: "Inter Tight",
//       padding: 0,
//     },
//     "& MuiAutocomplete-tag": {
//       padding: 0,
//       margin: 0,
//     },
//   },
//   "& .Mui-focused": {
//     outline: "unset",
//   },
//   "& .MuiOutlinedInput-notchedOutline": {
//     border: "1px solid #E8E8E8 !important",
//   },
// }));

// const CAutocomplete = ({
//   options,
//   isMultiSelect,
//   onChange,
//   value = isMultiSelect ? [] : null,
//   ...props
// }) => {
//   return (
//     <FormControl
//       variant="standard"
//       fullWidth
//       required={props?.required || false}
//       error={props?.error || false}
//     >
//       <InputLabel shrink htmlFor="input">
//         {props.label}
//       </InputLabel>
//       <CustomAutocomplete
//         id="input"
//         variant="contained"
//         multiple={isMultiSelect}
//         value={value}
//         onChange={onChange}
//         options={options}
//         getOptionLabel={props?.getOptionLabel ? props?.getOptionLabel : ""}
//         renderOption={props?.renderOption}
//         style={{
//           border: props?.error ? "1px solid red" : "",
//         }}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             variant="outlined"
//             placeholder={props?.placeholder || ""}
//           />
//         )}
//         {...props}
//       />
//       <FormHelperText
//         error={props?.error || false}
//         style={{ fontFamily: "Inter Tight" }}
//       >
//         {props?.helpertext || ""}
//       </FormHelperText>
//     </FormControl>
//   );
// };

// export default CAutocomplete;

//New UI dropdown component
import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { FormControl, FormHelperText, styled } from "@mui/material";

const CustomAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "& .MuiInputBase-input": {
    fontSize: 14,
  },
  "& .MuiOutlinedInput-root": {
    border: "none",
    fontSize: "14px",
    backgroundColor: "transparent",
    fontFamily: "Inter Tight",
    padding: "8px",
    "&.Mui-focused": {
      outline: "none",
    },
    "& .MuiAutocomplete-input": {
      padding: 0,
    },
    "& .MuiAutocomplete-root": {
      backgroundColor: "#fff",
    },
  },
}));

const FieldsetWrapper = styled("fieldset")(({ theme, error }) => ({
  borderRadius: "12px",
  padding: "8px 18px",
  border: error ? "1px solid red" : "1px solid rgba(18, 18, 21, 0.10)",
  backgroundColor: "#fff",
  fontFamily: "Inter Tight",
  transition: "border-color 0.3s ease",
  "&:focus-within": {
    borderColor: theme.palette.primary.main,
  },
}));

const Legend = styled("legend")(({ error }) => ({
  fontSize: "13px",
  fontWeight: "500",
  padding: "0 5px",
  color: error ? "red" : "#0D0D0E",
}));

const CAutocomplete = ({
  options,
  isMultiSelect,
  onChange,
  value = isMultiSelect ? [] : null,
  ...props
}) => {
  return (
    <FormControl
      variant="standard"
      fullWidth
      required={props?.required || false}
      error={props?.error || false}
    >
      <FieldsetWrapper error={props?.error}>
        {props.label && <Legend error={props?.error}>{props.label}</Legend>}
        <CustomAutocomplete
          id="input"
          multiple={isMultiSelect}
          variant="contained"
          value={value}
          onChange={onChange}
          options={options}
          getOptionLabel={props?.getOptionLabel || ((option) => option)}
          renderOption={props?.renderOption}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder={props?.placeholder || ""}
              InputProps={{ ...params.InputProps, disableUnderline: true }}
              style={{background:"#fff"}}
            />
          )}
          {...props}
        />
      </FieldsetWrapper>

      <FormHelperText
        error={props?.error || false}
        style={{ fontFamily: "Inter Tight" }}
      >
        {props?.helpertext || ""}
      </FormHelperText>
    </FormControl>
  );
};

export default CAutocomplete;
